import { z } from 'zod/v4';

// ==================== Query Schemas ====================

export const chartQuerySchema = z.object({
  days: z.coerce.number().min(7, 'Минимум 7 дней').max(365, 'Максимум 365 дней').optional().default(30),
});

export type ChartQueryDto = z.infer<typeof chartQuerySchema>;

export const cohortQuerySchema = z.object({
  months: z.coerce.number().min(1, 'Минимум 1 месяц').max(12, 'Максимум 12 месяцев').optional().default(6),
});

export type CohortQueryDto = z.infer<typeof cohortQuerySchema>;

export const dailyStatsQuerySchema = z.object({
  page: z.coerce.number().int().min(1, 'Страница должна быть >= 1').optional().default(1),
  limit: z.coerce.number().int().min(1, 'Лимит должен быть >= 1').max(365, 'Лимит должен быть <= 365').optional().default(30),
  sortBy: z.enum(['date', 'newUsers', 'activeUsers', 'revenue']).optional().default('date'),
  sortOrder: z.enum(['asc', 'desc']).optional().default('desc'),
});

export type DailyStatsQueryDto = z.infer<typeof dailyStatsQuerySchema>;

// ==================== Response Types ====================

export interface OverviewResponse {
  totalUsers: number;
  activeSubscriptions: number;
  totalRevenue: number;
  todayNewUsers: number;
  mrr: number;
}

export interface ChartDataPoint {
  date: string;
  [key: string]: string | number;
}

export interface ChartResponse<T extends ChartDataPoint> {
  data: T[];
  period: string;
}

export interface UserChartDataPoint extends ChartDataPoint {
  total: number;
  new: number;
  active: number;
}

export interface RevenueChartDataPoint extends ChartDataPoint {
  revenue: number;
  mrr: number;
}

export interface ChurnChartDataPoint extends ChartDataPoint {
  churnRate: number;
  expired: number;
}

export interface CohortRetention {
  month: number;
  count: number;
  rate: number;
}

export interface Cohort {
  cohort: string;
  users: number;
  retained: CohortRetention[];
}

export interface CohortResponse {
  cohorts: Cohort[];
}

export interface RefreshStatsResponse {
  date: string;
  stats: {
    totalUsers: number;
    newUsers: number;
    activeSubscriptions: number;
    mrr: number;
    churnRate: string;
  };
  message: string;
}

export interface DailyStatItem {
  id: number;
  date: string;
  newUsers: number;
  activeUsers: number;
  newSubscriptions: number;
  totalIncome: number;
  createdAt: string;
}
